import { PLATFORMS_LINE } from '../../constants';
import createAccountDark from '../../../../assets/playerCafe/screens/01-create-account-dark.webp';
import createAccountLight from '../../../../assets/playerCafe/screens/01-create-account-light.webp';
import avatarDark from '../../../../assets/playerCafe/screens/02-avatar-dark.webp';
import avatarLight from '../../../../assets/playerCafe/screens/02-avatar-light.webp';
import gamesDark from '../../../../assets/playerCafe/screens/03-games-dark.webp';
import gamesLight from '../../../../assets/playerCafe/screens/03-games-light.webp';
import scheduleDark from '../../../../assets/playerCafe/screens/04-schedule-dark.webp';
import scheduleLight from '../../../../assets/playerCafe/screens/04-schedule-light.webp';
import filterGamesDark from '../../../../assets/playerCafe/screens/05-filter-games-dark.webp';
import filterGamesLight from '../../../../assets/playerCafe/screens/05-filter-games-light.webp';
import filterHoursDark from '../../../../assets/playerCafe/screens/06-filter-hours-dark.webp';
import filterHoursLight from '../../../../assets/playerCafe/screens/06-filter-hours-light.webp';
import homeDeckDark from '../../../../assets/playerCafe/screens/07-home-deck-dark.webp';
import homeDeckLight from '../../../../assets/playerCafe/screens/07-home-deck-light.webp';
import requestsDark from '../../../../assets/playerCafe/screens/08-requests-dark.webp';
import requestsLight from '../../../../assets/playerCafe/screens/08-requests-light.webp';
import chatDark from '../../../../assets/playerCafe/screens/09-chat-dark.webp';
import chatLight from '../../../../assets/playerCafe/screens/09-chat-light.webp';
import settingsDark from '../../../../assets/playerCafe/screens/10-settings-dark.webp';
import settingsLight from '../../../../assets/playerCafe/screens/10-settings-light.webp';

export interface Slide {
  title: string;
  lead: string;
  points: string[];
  gesture?: string;
  screens: {
    dark: string;
    light: string;
  };
}

export const SLIDES: Slide[] = [
  {
    title: 'Create your account',
    screens: {
      dark: createAccountDark,
      light: createAccountLight,
    },
    lead: 'Sign up in four short steps: your login, a quick phone check, a little about you, and a username.',
    points: [
      'Sign in with Apple, Google or email.',
      'A text message confirms your phone number.',
      'Pick a username. It\'s how people will know you.',
    ],
  },
  {
    title: 'Make your avatar',
    screens: {
      dark: avatarDark,
      light: avatarLight,
    },
    lead: 'Build a character that\'s yours. Choose a style for each feature, then tune its color.',
    points: [
      'Hair, eyes, mouth and more, each with its own gallery.',
      'Three sliders set the color, its vibrancy and its darkness.',
    ],
  },
  {
    title: 'Add your games',
    screens: {
      dark: gamesDark,
      light: gamesLight,
    },
    lead: 'Search for a game, pick the platform you play it on, and add it to your list.',
    points: [
      `Covers ${PLATFORMS_LINE}.`,
      'Your games are how people who play the same ones find you.',
    ],
  },
  {
    title: 'Set your gaming hours',
    screens: {
      dark: scheduleDark,
      light: scheduleLight,
    },
    lead: 'Mark the hours you usually play, day by day. A day can have more than one block.',
    points: [
      'Drag the ends of a block to change it.',
      'Traveling? Choose whether people see your home hours or the hours where you are.',
    ],
  },
  {
    title: 'Filter by games',
    screens: {
      dark: filterGamesDark,
      light: filterGamesLight,
    },
    lead: 'Only see people who play the games you\'re looking for.',
    points: [
      'Match your own games with one switch, or pick specific ones.',
      'Turn on cross-platform when the platform doesn\'t matter.',
      'Turning a filter off keeps all of your selections.',
    ],
  },
  {
    title: 'Filter by hours',
    screens: {
      dark: filterHoursDark,
      light: filterHoursLight,
    },
    lead: 'Only see people who are around when you are.',
    points: [
      'Match your own gaming schedule with one switch.',
      'Or set different hours just for searching.',
    ],
  },
  {
    title: 'Find people',
    screens: {
      dark: homeDeckDark,
      light: homeDeckLight,
    },
    lead: 'Each card shows how well you line up: the games you share, the days you overlap, and the hours you\'re both on.',
    points: [
      'Changed your mind? Undo within five seconds.',
      'You can send 20 requests a day. Passing is always free.',
      'Tap a card to see the whole profile.',
    ],
    gesture: 'Swipe right to send a request · Swipe left to pass',
  },
  {
    title: 'Connect',
    screens: {
      dark: requestsDark,
      light: requestsLight,
    },
    lead: 'Requests from other people land here. Open one to see their card, then decide.',
    points: [
      'Accept, and you\'re connected.',
      'Declined by mistake? You have ten seconds to undo.',
      'A dot marks anything new.',
    ],
    gesture: 'Swipe right to accept · Swipe left to decline',
  },
  {
    title: 'Chat',
    screens: {
      dark: chatDark,
      light: chatLight,
    },
    lead: 'Once you\'re connected, start chatting and plan your first game.',
    points: [
      'Get notified about new messages, requests and connections.',
      'Unmatch or report someone from your chats at any time.',
    ],
  },
  {
    title: 'Stay in control',
    screens: {
      dark: settingsDark,
      light: settingsLight,
    },
    lead: 'Settings decides who can see you and what reaches you.',
    points: [
      'Choose the age range that can see your profile.',
      'Turn notifications on or off by type.',
      'Disable your account for a break, or delete it for good.',
    ],
  },
];
